import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { DeleteDesignDialog } from '@component/Dialog';
import { ArrowThumbnail3DContainer } from '@container/thumbnail';
import type { DesignSet } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';

export const KEY = 'your-design-delete';

const selectShowDialog = (state: AppState): boolean => state.uiDialog.states[KEY]?.show || false;

const selectDialogItem = (
    state: AppState,
): DesignSet => state.uiDialog.states[KEY]?.userData as DesignSet;

const selectOkHandler = (state: AppState) => state.uiDialog.states[KEY]?.okHandler;

const selectCancelHandler = (state: AppState) => state.uiDialog.states[KEY]?.cancelHandler;

export const DeleteDesignDialogContainer: FC = () => {
    const showDialog = useSelector(selectShowDialog);
    const item = useSelector(selectDialogItem);
    const okHandler = useSelector(selectOkHandler);
    const cancelHandler = useSelector(selectCancelHandler);

    return (
        <DeleteDesignDialog
            thumbnail={
                <ArrowThumbnail3DContainer item={item} hideCustomize />
            }
            isShow={showDialog}
            delBtnProps={{
                onClick: okHandler || undefined,
            }}
            cancelBtnProps={{
                onClick: cancelHandler || undefined,
            }}
        />
    );
};
